import { Menu, MenuButton } from '@headlessui/react'
import { useNavigate } from 'react-router-dom'

import ListDropdown from '@Icons/list-dropdown.svg?react'
import MainHeader from '@Layouts/MainHeader'
import Mixpanel from '@Utils/mixpanel/Mixpanel'

import ExportButton from './export-button'
import ManageDropdown from './ManageDropdown'
import ButtonDown300 from '../../../assets/images/icons/button-down-icon-300.svg?react'

type ProductHeaderProps = {
  productCount?: number
  totalProducts?: number
  isLoading: boolean
  isInitiated?: boolean
}

function ProductHeader({
  productCount,
  totalProducts,
  isLoading,
  isInitiated = false,
}: ProductHeaderProps): JSX.Element {
  const navigate = useNavigate()

  const sendEvent = (event: string): void => {
    Mixpanel.track(event, {
      page: 'Products',
      section: 'Header',
    })
  }

  const handleImportClick = (): void => {
    sendEvent('Import Button Clicked')
    navigate('/data-management')
  }

  return (
    <MainHeader
      isLoading={!isInitiated}
      title="Products"
      subtitle={
        isLoading ? (
          <div className="animate-pulse bg-gray-200 h-2 w-2/5 rounded-md mt-2"></div>
        ) : productCount ? (
          <span className="pr-2 font-medium text-base text-gray-500">
            {totalProducts !== undefined && productCount !== totalProducts
              ? `${productCount.toLocaleString()} of ${totalProducts.toLocaleString()} products matched`
              : `${productCount.toLocaleString()} products found.`}
          </span>
        ) : (
          <></>
        )
      }
      extra={
        <>
          <div className="inline-flex items-start">
            {productCount ? (
              <ManageDropdown />
            ) : (
              <button disabled className="pr-3">
                <div className="flex flex-row items-center justify-center px-4 py-2.5 border border-solid rounded-lg border-gray-200 text-gray-300">
                  <span className="pr-3">Manage</span>
                  <ButtonDown300 />
                </div>
              </button>
            )}
            <ExportButton
              options={[
                { text: '.zip Horizontal', value: 'zip_horizontal' },
                { text: '.xlsx Horizontal', value: 'xlsx_horizontal' },
                { text: '.csv Horizontal', value: 'csv_horizontal' },
                { text: '.zip Vertical', value: 'zip_vertical' },
                { text: '.xlsx Vertical', value: 'xlsx_vertical' },
                { text: '.csv Vertical', value: 'csv_vertical' },
              ]}
            />
          </div>
          <Menu as="div" className="relative text-left sm:pt-0 w-full sm:w-min">
            <MenuButton
              className={`flex flex-row items-center justify-center px-3 lg:px-4 py-2.5 border border-solid rounded-lg 'border-primary-600 bg-primary-600 w-full`}
              onClick={handleImportClick}
            >
              <ListDropdown
                className={`mr-2 w-[20px] h-[20px] [&>*]:stroke-white-100`}
              />
              <span className={`mr-2 pr-2 text-white-100`}>Import</span>
            </MenuButton>
          </Menu>
        </>
      }
    />
  )
}

export default ProductHeader
